var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 3.66683H7.66666V5.00016H6.33333V3.66683Z",
    fill: "#526069"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 6.3335H7.66666V10.3335H6.33333V6.3335Z",
    fill: "#526069"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.333328 7.00016C0.333328 3.32017 3.31998 0.333496 7 0.333496C10.68 0.333496 13.6667 3.32017 13.6667 7.00016C13.6667 10.6802 10.68 13.6668 7 13.6668C3.31998 13.6668 0.333328 10.6802 0.333328 7.00016ZM1.66666 7.00016C1.66666 9.94017 4.05997 12.3335 7 12.3335C9.94002 12.3335 12.3333 9.94017 12.3333 7.00016C12.3333 4.06016 9.94002 1.66683 7 1.66683C4.05997 1.66683 1.66666 4.06016 1.66666 7.00016Z",
    fill: "#526069"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoGray);
export default __webpack_public_path__ + "static/media/info_gray.1c0a124cf9dd925cc323d8bdb8f620c8.svg";
export { ForwardRef as ReactComponent };